import React, { useEffect, useContext } from 'react'
import { Modal, Form, Input, Button, Space, InputNumber } from 'antd'
import { AppContext } from 'AppContext'
import { canUserEdit, canUserAdd, canUserSave } from 'utils/User'

const PrioritySlaConfigModal = ({
  visible,
  onCancel,
  onOk,
  editingPrioritySlaConfig,
}) => {
  const { state: { currentUser, userPermissions, isClient } = {} } = useContext(AppContext) || {}
  const hasEdit = canUserEdit(userPermissions || currentUser, isClient)
  const hasAdd = canUserAdd(userPermissions || currentUser, isClient)
  const hasSave = canUserSave(userPermissions || currentUser, isClient)
  const canSubmit = editingPrioritySlaConfig ? (hasEdit && hasSave) : (hasAdd && hasSave)

  const [form] = Form.useForm()

  useEffect(() => {
    if (editingPrioritySlaConfig) {
      form.setFieldsValue({
        ...editingPrioritySlaConfig,
        departmentHead: editingPrioritySlaConfig.head?.id,
      })
    } else {
      form.resetFields()
    }
  }, [editingPrioritySlaConfig, form])

  const handleSubmit = () => {
    if (!canSubmit) return
    form.validateFields().then((values) => {
      onOk(values)
    })
  }

  return (
    <Modal
      title={editingPrioritySlaConfig ? 'Edit Priority' : 'Add Priority'}
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          label='Priority'
          name='priorityLevel'
          rules={[{ required: true, message: 'Please enter priority level' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label='SLA time in hours' name='slaTime'>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item>
          <Space
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Button onClick={onCancel}>Cancel</Button>
            <Button type='primary' onClick={handleSubmit} disabled={!canSubmit}>
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default PrioritySlaConfigModal
